import { FC } from 'react'

interface Props {
  city?: string
  state?: string
  regionType: string
}

const Breadcrumb: FC<Props> = ({ city, state, regionType }) => {
  return (
    <div className="display-flex justify-content-space-between ">
      <nav data-cy="breadcrumb" aria-label="Breadcrumb">
        <ol className="Breadcrumb mb-4">
          <li className="Breadcrumb-itemContainer">
            <a
              className="Breadcrumb-item text-white"
              href="https://www.bankrate.com/real-estate/"
            >
              Real Estate
            </a>
          </li>
          <li className="Breadcrumb-itemContainer">
            <a
              className="Breadcrumb-item text-white"
              href="https://www.bankrate.com/real-estate/housing-market/us/"
            >
              Housing Market
            </a>
          </li>

          {regionType === 'state' && (
            <>
              <li className="Breadcrumb-itemContainer">
                <span
                  className="Breadcrumb-item text-white"
                  style={{ textDecoration: 'none' }}
                >
                  {state}
                </span>
              </li>
            </>
          )}

          {regionType === 'place' && (
            <>
              <li className="Breadcrumb-itemContainer">
                <a
                  className="Breadcrumb-item text-white"
                  href={`https://www.bankrate.com/real-estate/housing-market/${state?.toLowerCase()}/`}
                >
                  {state}
                </a>
              </li>
              <li className="Breadcrumb-itemContainer">
                <span
                  className="Breadcrumb-item text-white"
                  style={{ textDecoration: 'none' }}
                >
                  {city}
                </span>
              </li>
            </>
          )}
        </ol>
      </nav>
    </div>
  )
}

export default Breadcrumb
